/** Carries a refused signup code across a full-page redirect (Stripe Checkout) to a notice on return. */

const STORAGE_KEY = "versafy.rejected-signup-code"

export const REJECTED_SIGNUP_CODE_MESSAGE =
  "We couldn't apply the partner code you entered — it may be inactive or mistyped. Your account was created normally."

export function rememberRejectedSignupCode(): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, "1")
  } catch {
    // Storage blocked: the notice is a courtesy, the signup itself succeeded.
  }
}

/** True once per remembered refusal. */
export function takeRejectedSignupCode(): boolean {
  try {
    if (sessionStorage.getItem(STORAGE_KEY) === null) return false
    sessionStorage.removeItem(STORAGE_KEY)
    return true
  } catch {
    return false
  }
}
